export enum DigitalSignatureFlowEnum {
    uninitiated = 1,
    registered = 2,
    awatingConfirmation = 3,
    authenticated = 4,
    signable = 5,
}